import styled, { css } from 'styled-components'
import colors from '../../styles/colors'
import mediaQuery from 'styles/mediaQuery'

export const gradientRotate = '94.96'
export const gradientFrom = {
  offset: '8.93%',
  color: '#F26BCD',
  hoverColor: '#EF58C6',
  activeColor: '#F26BCD',
}
export const gradientTo = {
  offset: '94.95%',
  color: '#C567F4',
  hoverColor: '#BB51F0',
  activeColor: '#F264CB',
}

export const gradients = {
  mainGradient: `linear-gradient(${gradientRotate}deg, ${gradientFrom.color} ${gradientFrom.offset}, ${gradientTo.color} ${gradientTo.offset})`,
  hoverGradient: `linear-gradient(${gradientRotate}deg, ${gradientFrom.hoverColor} ${gradientFrom.offset}, ${gradientTo.hoverColor} ${gradientTo.offset})`,
  activeGradient: `linear-gradient(${gradientRotate}deg, ${gradientFrom.activeColor} ${gradientFrom.offset}, ${gradientTo.activeColor} ${gradientTo.offset})`,
}

export const interactiveText = css`
  background: ${gradients.mainGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

export const magicContainerStyle = css`
  width: 1140px;
  padding: 0 15px;
  margin: 0 auto;
  max-width: 100%;
`

export const Container = styled.div`
  ${magicContainerStyle};
`

const buttonStyle = css`
  border-radius: 50px;
  padding: 12px 28px;
  font-size: 14px;
  line-height: 20px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
`

export const purpleButtonStyle = css`
  ${buttonStyle};
  background: linear-gradient(94.96deg, #f26bcd 8.93%, #c567f4 94.95%);
  color: ${colors.black};
  opacity: 1;

  &:hover {
    opacity: 0.8;
  }
`

export const purpleOutlineButtonStyle = css`
  ${buttonStyle};
  border: 1px solid #f26bcd;
  color: ${colors.white};
  background: linear-gradient(94.96deg, transparent 8.93%, transparent 94.95%);
  opacity: 1;

  &:hover {
    opacity: 0.8;
  }
`

export const titleStyleBase = css`
  font-weight: 600;
  line-height: 1.25;
  color: ${colors.white};
`

export const titleStyle1 = css`
  ${titleStyleBase};
  margin-bottom: 24px;
  font-size: 32px;

  ${mediaQuery.tabletMin} {
    font-size: 60px;
  }
`

export const titleStyle2 = css`
  ${titleStyleBase};
  font-size: 24px;

  ${mediaQuery.tablet} {
    font-size: 36px;
  }

  ${mediaQuery.bigTabletMin} {
    font-size: 48px;
  }
`

export const titleStyle3 = css`
  ${titleStyleBase};
  font-size: 20px;
`

export const textStyleBase = css`
  font-weight: 400;
  color: ${colors.gray2};
`

export const textStyle1 = css`
  ${textStyleBase};
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 24px;
`

export const textStyle2 = css`
  ${textStyleBase};
  font-size: 14px;
  line-height: 26px;
`
